import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-error-60px",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_2 = { class: "modal-error-integrations__description" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "dialog" };
const _hoisted_5 = { class: "btn modal-error-integrations__button" };
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalErrorIntegrations',
    props: {
        isVisible: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const isVisible = ref(false);
        const audienceId = computed(() => store.getters['audienceManager/getAudienceId']);
        onMounted(() => {
            isVisible.value = props.isVisible;
        });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                id: "audience-update-error-integrations",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                class: "modal-error-integrations",
                width: "500"
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('audiences.error-updated')), 1),
                    _createElementVNode("a", {
                        href: `/base-management/base-audiences/view/${_unref(store).getters.user.id}/${audienceId.value}`
                    }, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('continue')), 1)
                        ])
                    ], 8, _hoisted_3)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
